export default __webpack_public_path__ + "static/dk-601ee70c0594ee1cb19bb2cfd0bc71b5.svg";